import { useTranslation } from 'react-i18next';
import { ArrowLeftLineIcon, Button, CheckboxInput, Col, Form, Row, Section, TextInput } from 'ui';

type P = {
  loading: boolean;
  onNavigateToPrimaryLogin: () => void;
  onSubmit: (data: { email: string }) => void;
};

const PasswordLessLoginForm = ({ loading, onNavigateToPrimaryLogin, onSubmit }: P) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = (data: { email: string }) => {
    onSubmit(data);
  };

  return (
    <Form
      className="onboarding-password-login-form__form"
      form={form}
      initialValues={{ remember: true }}
      onFinish={onFinish}
    >
      <Row align="middle">
        <Col span={24}>
          <TextInput
            input={{
              autoComplete: 'email',
            }}
            item={{
              label: 'Email',
              name: 'email',
              rules: [
                {
                  type: 'email',
                },
                {
                  required: true,
                  whitespace: true,
                },
              ],
            }}
          />
        </Col>
        <Col span={24}>
          <CheckboxInput
            item={{
              label: t('Remember me'),
              name: 'remember',
              valuePropName: 'checked',
            }}
          />
        </Col>
      </Row>
      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button block htmlType="submit" loading={loading} size="large" type="primary">
              E-mail me a log in link
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              icon={<ArrowLeftLineIcon />}
              onClick={() => {
                onNavigateToPrimaryLogin();
              }}
              size="large"
            >
              All log in options
            </Button>
          </Col>
        </Row>
      </Section>
    </Form>
  );
};

export default PasswordLessLoginForm;
